<template>
  <div>
    <h2 class="commonHeadingBlack paddingB3">注目イベント</h2>
    <scrollable-box v-if="isInPcMode" class="sliderList">
      <div v-for="(event, index) in attentionEvents" :key="index" class="scrollItem sliderList-item" @click="sendOpixAttentionEvent(event)">
        <div v-if="event.catch_copy" class="sliderList-item-prText">
          <span class="threeDotText sliderList-item-prText-content">{{ event.catch_copy }}</span>
        </div>
        <custom-nuxt-link :to="event.url">
          <common-lazy-load-image v-if="event.banner" :image-object="event.banner" :is-fixed-dimension="false" :alt="event.name" />
        </custom-nuxt-link>
        <div class="sliderList-item-infor">
          <span v-if="event.area" class="sliderList-item-infor-area marginR2">{{ event.area }}</span>
          <span v-if="event.day" class="sliderList-item-infor-timer">{{ event.day }}</span>
        </div>
        <span class="sliderList-item-title titleEvent threeDotText"> {{ event.name }} </span>
      </div>
    </scrollable-box>
    <client-only v-else>
      <carousel ref="carousel" :wrap-around="true" class="sliderList">
        <slide v-for="(event, index) in attentionEvents" :key="index" class="sliderList-item" @click="sendOpixAttentionEvent(event)">
          <custom-nuxt-link :to="event.url">
            <div v-if="event.catch_copy" class="sliderList-item-prText">
              <span class="threeDotText sliderList-item-prText-content">{{ event.catch_copy }}</span>
            </div>
            <common-lazy-load-image v-if="event.banner" :image-object="event.banner" :is-fixed-dimension="true" :alt="event.name" />
            <div class="sliderList-item-infor">
              <span v-if="event.area" class="sliderList-item-infor-area marginR2">{{ event.area }}</span>
              <span v-if="event.day" class="sliderList-item-infor-timer">{{ event.day }}</span>
            </div>
            <span class="sliderList-item-title threeDotText"> {{ event.name }} </span>
          </custom-nuxt-link>
        </slide>
        <template v-if="attentionEvents.length > 1" #addons>
          <navigation>
            <template #next>
              <span v-html="navigationNext"></span>
            </template>
            <template #prev>
              <span v-html="navigationPrev"></span>
            </template>
          </navigation>
        </template>
      </carousel>
    </client-only>
  </div>
</template>

<script>
import { Carousel, Slide, Navigation } from 'vue3-carousel/dist/carousel.es.js'
import 'vue3-carousel/dist/carousel.css'
const CommonLazyLoadImage = defineAsyncComponent(() => import('@/components/CommonLazyLoadImage.vue'))
const ScrollableBox = defineAsyncComponent(() => import('@/components/ScrollableBox.vue'))

export default {
  components: { Carousel, Slide, Navigation, CommonLazyLoadImage, ScrollableBox },
  props: {
    events: { type: Array, default: () => [], required: true }
  },
  data() {
    return {
      isInPcMode: true // For handle HierarchyRequestError
    }
  },
  computed: {
    navigationNext() {
      return `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa fa-angle-right fa-w-8" ><path fill="currentColor" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>`
    },
    navigationPrev() {
      return `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa fa-angle-left fa-w-8" ><path fill="currentColor" d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path></svg>`
    },
    attentionEvents() {
      return this.events.map(event => {
        return {
          ...event,
          url: event.url.startsWith('/') ? event.url : '/' + event.url
        }
      })
    }
  },
  watch: {
    isSP() {
      this.isInPcMode = !this.$store.isSP
    }
  },
  mounted() {
    this.isInPcMode = !this.$store.isSP
  },
  methods: {
    nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage())
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage())
    },
    sendOpixAttentionEvent(event) {
      const data = {
        path: event.url,
        showedBlock: 'attention events'
      }
      this.$emit('click-attention-event', data)
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.carousel) {
  .carousel__prev,
  .carousel__next {
    height: 40px;
    width: 25px;
    border: none;
    outline: none;
    background-color: rgba($black-1a, 0.6);
    color: $white;
    margin: unset;
    svg {
      position: absolute;
      font-size: 2.4rem;
    }
  }
  .carousel__prev {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    svg {
      left: 7px;
      top: 8px;
    }
  }
  .carousel__next {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    svg {
      left: 7px;
      top: 8px;
    }
  }
}
.sliderList {
  color: $black-1a;
  .scrollItem {
    width: 290px;
    @media screen and (min-width: 360px) {
      width: 330px;
    }
    @media screen and (min-width: 375px) {
      width: 345px;
    }
    @media screen and (min-width: 411px) {
      width: 381px;
    }
    @media screen and (min-width: 414px) {
      width: 384px;
    }
    @media screen and (min-width: 768px) {
      width: 738px;
    }
  }
  &-item {
    height: 100%;
    position: relative;
    padding: 1.5rem;
    border-radius: 1.2rem;
    box-shadow: 0 0 3px $gray-c6;
    background-color: $white;
    text-align: left;
    .threeDotText {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      color: $gray-55;
      font-weight: 400;
    }
    img {
      width: 100%;
      height: auto;
      max-height: 44vw;
      border: 1px solid $gray-f1;
    }
    &-infor {
      display: inline-block;
      &-area {
        @include textEllipsis;
        display: block;
        float: left;
        min-width: 60px;
        max-width: 100px;
        padding: 0.1rem 0.6rem;
        border-radius: 3px;
        color: $white;
        font-size: 1.2rem;
        text-align: center;
        background-color: $gray-55;
      }
      &-timer {
        position: relative;
        top: 0.2rem;
        float: left;
        color: $black-1a;
        font-weight: bold;
        font-size: 1.2rem;
      }
    }
    &-prText {
      width: 100%;
      text-align: center;
      font-size: 1.4rem;
      font-weight: bold;
      background-image: url('@/assets/images/ribbon.svg');
      height: 3.9rem;
      padding-top: 0.4rem;
      background-position: top center;
      background-size: contain;
      background-repeat: no-repeat;
      @include sp {
        @media screen and (min-width: 360px) {
          padding-top: 0.5rem;
          height: 4.4rem;
        }
        @media screen and (min-width: 375px) {
          padding-top: 0.8rem;
          height: 4.7rem;
        }
        @media screen and (min-width: 411px) {
          padding-top: 1rem;
          height: 5rem;
        }
        @media screen and (min-width: 414px) {
          height: 5.2rem;
        }
        @media screen and (min-width: 768px) {
          padding-top: 2.3rem;
          height: 7.8rem;
          background-image: url('@/assets/images/ribbon_pc.svg');
        }
      }
      &-content {
        -webkit-line-clamp: 1;
        margin: 0 3rem;
      }
    }
    &-navigation {
      position: absolute;
      top: 36%;
      height: 40px;
      width: 25px;
      border: none;
      background-color: rgba($black-1a, 0.6);
      color: $white;
      z-index: 999;
      outline: 0;
      @media screen and (min-width: 360px) {
        top: 38%;
      }
      @media screen and (min-width: 375px) {
        top: 39%;
      }
      @media screen and (min-width: 411px) {
        top: 41%;
      }
      @media screen and (min-width: 768px) {
        top: 46%;
      }
      &.prev {
        left: 0;
        border-bottom-right-radius: 3px;
        border-top-right-radius: 3px;
      }
      &.next {
        right: 0;
        border-bottom-left-radius: 3px;
        border-top-left-radius: 3px;
      }
    }
    &-title {
      font-size: 1.4rem;
      font-weight: bold;
      -webkit-line-clamp: 1;
    }
  }
}

:deep() {
  @include pc {
    .scrollableBox-inner {
      margin: auto;
      gap: 2rem;
      .scrollItem {
        width: calc((92.8rem - 2rem * 2) / 3);
        border-radius: 1.2rem;
        box-shadow: 0 0 3px $gray-c6;
        a {
          display: block;
        }
      }
    }
  }
}
</style>
